import React, { useState } from 'react';
import { Stack, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function PrescriptionEntry({ onAdd, disabled }) {
  const [form, setForm] = useState({
    name: '',
    dose: '',
    route: 'PO',
    frequency: 'QD',
  });

  const canAdd = form.name && form.dose && form.route && form.frequency;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 2 }}>
      <TextField
        size="small" label="Medication" sx={{ flex: 2 }}
        value={form.name} onChange={(e) => setForm(s => ({ ...s, name: e.target.value }))}
      />
      <TextField
        size="small" label="Dose" sx={{ width: 140 }}
        value={form.dose} onChange={(e) => setForm(s => ({ ...s, dose: e.target.value }))}
      />
      <FormControl size="small" sx={{ width: 110 }}>
        <InputLabel>Route</InputLabel>
        <Select
          label="Route" value={form.route}
          onChange={(e) => setForm(s => ({ ...s, route: e.target.value }))}
        >
          {['PO','SC','INH','IM','IV'].map(v => <MenuItem key={v} value={v}>{v}</MenuItem>)}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ width: 130 }}>
        <InputLabel>Frequency</InputLabel>
        <Select
          label="Frequency" value={form.frequency}
          onChange={(e) => setForm(s => ({ ...s, frequency: e.target.value }))}
        >
          {['QD','BID','TID','QHS','PRN','Q6H'].map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
        </Select>
      </FormControl>
      <Button
        size="small" startIcon={<AddIcon />}
        disabled={disabled || !canAdd}
        onClick={() => {
          onAdd?.(form);
          setForm({ name: '', dose: '', route: 'PO', frequency: 'QD' });
        }}
      >
        Add Rx
      </Button>
    </Stack>
  );
}
